var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from "react";
import { connect } from "react-redux";
import { IdStyles } from "../../less/IdStyles";
import { selectBuildingConstructionTime } from "../../selectors/selectExistingBuildingInfo";
import { BuildingStateType } from "../../utils/network/generated/protoTypes";
import { utilTime } from "../../utils/utilTime";
import { IconWithProgress } from "../generic/icon-with-progress/IconWithProgress";
import { IdIcon } from "../generic/icon/IdIcon";
import { RemainingTimeDisplay } from "../generic/remaining-time-display/RemainingTimeDisplay";
import { HOCTimer } from "../generic/timer/HOCTimer";
var CalloutRunningProcessDOM = /** @class */ (function (_super) {
    __extends(CalloutRunningProcessDOM, _super);
    function CalloutRunningProcessDOM() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CalloutRunningProcessDOM.prototype.render = function () {
        var _a = this.props, remainingTime = _a.remainingTime, duration = _a.duration;
        var secondsLeft = utilTime.secondsLeftTill(remainingTime);
        var progress = utilTime.timerProgressReversed(secondsLeft, duration);
        return (React.createElement(IconWithProgress, { progressPercent: progress, icon: IdIcon.TimeIcn, iconStyle: IdStyles.IconMedium, fillClassName: IdStyles.ProgressBarFill, backgroundClassName: IdStyles.ProgressBarBackground },
            React.createElement(RemainingTimeDisplay, { seconds: secondsLeft, className: IdStyles.TextNormal })));
    };
    CalloutRunningProcessDOM = __decorate([
        HOCTimer(true)
    ], CalloutRunningProcessDOM);
    return CalloutRunningProcessDOM;
}(React.Component));
var mapState = function (state, props) {
    var _a = props.building, proto = _a.proto, balancing = _a.balancing;
    var buildingTypeId = balancing.id;
    var level = proto.stage || 1;
    if (proto.state === BuildingStateType.UPGRADING) {
        level += 1;
    }
    var totalTime = selectBuildingConstructionTime(state, buildingTypeId, level);
    return {
        duration: totalTime,
        remainingTime: proto.remainingTime || utilTime.now(),
    };
};
export var CalloutRunningProcess = connect(mapState)(CalloutRunningProcessDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/callouts/CalloutRunningProcess.tsx
// module id = 2236
// module chunks = 3